import React, { useState } from 'react';
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form
import './Section_8.css';

function Section8({ sectionConfig }) {

  const [showSurvey, setShowSurvey] = useState(false);
  const handleCloseSurvey = () => {
      setShowSurvey(false);
    };

    const handleButtonClick = (button) => {
  if (button.path === "\/") {
    setShowSurvey(true);
  } else {
    window.location.href = button.path;
  }
};

  if (!sectionConfig) return null;


  const backgroundStyle = getBackground(sectionConfig.bg_color);

  return (
    <>
    <section className="section-8" style={{ background : sectionConfig.isCard ? "transparent" : backgroundStyle }}>
      <div className="section-8-card" style={{ background : sectionConfig.isCard ? backgroundStyle: "transparent" }}>
        <h2 className="section-8-title">{sectionConfig.title}</h2>
        <p className="section-8-description">
          {sectionConfig.description}
        </p>
        <div className="buttons-row">
  {sectionConfig.buttons.map((button, index) => (
    <button
      key={index}
      className={button.primary ? "btn primary" : "btn secondary"}
      onClick={() => handleButtonClick(button)}
    >
      {button.name}
    </button>
  ))}
</div>
      </div>
    </section>
    {/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}

function getBackground(bgColors) {
  
  if (!bgColors || bgColors.length === 0) return "#333"; // fallback
  return bgColors.length === 1
    ? bgColors[0]
    : `linear-gradient(90deg, ${bgColors.join(", ")})`;
}

export default Section8;